import React from "react";
import { SVGIconProps } from "./SVGIconProps";
function Close24(props: SVGIconProps) {
    const { onClick } = props;
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onClick}>
            <path d="M19 5L5 19M5 5L19 19" stroke="#7A869A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
}
export default Close24;
